import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { CheckoutShipping } from "@components/organisms";
import { useCheckout } from "@saleor/sdk";

var CheckoutShippingSubpageWithRef = function CheckoutShippingSubpageWithRef(_ref, ref) {
  var _checkout$shippingMet;

  var changeSubmitProgress = _ref.changeSubmitProgress,
      onSubmitSuccess = _ref.onSubmitSuccess,
      props = _objectWithoutProperties(_ref, ["changeSubmitProgress", "onSubmitSuccess"]);

  var checkoutShippingFormId = "shipping-form";
  var checkoutShippingFormRef = useRef(null);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      availableShippingMethods = _useCheckout.availableShippingMethods,
      setShippingMethod = _useCheckout.setShippingMethod;

  var shippingMethods = availableShippingMethods || [];
  useImperativeHandle(ref, function () {
    return {
      submitShipping: function submitShipping() {
        var _checkoutShippingForm;

        (_checkoutShippingForm = checkoutShippingFormRef.current) === null || _checkoutShippingForm === void 0 ? void 0 : _checkoutShippingForm.dispatchEvent(new Event("submit", {
          cancelable: true
        }));
      }
    };
  });

  var handleSetShippingMethod =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(shippingMethodId) {
      var _ref3, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              changeSubmitProgress(true);
              _context.next = 3;
              return setShippingMethod(shippingMethodId);

            case 3:
              _ref3 = _context.sent;
              dataError = _ref3.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;
              changeSubmitProgress(false);

              if (errors) {
                setErrors(errors);
              } else {
                setErrors([]);
                onSubmitSuccess();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSetShippingMethod(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return React.createElement(CheckoutShipping, _extends({}, props, {
    shippingMethods: shippingMethods,
    selectedShippingMethodId: checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingMet = checkout.shippingMethod) === null || _checkout$shippingMet === void 0 ? void 0 : _checkout$shippingMet.id,
    errors: errors,
    selectShippingMethod: handleSetShippingMethod,
    formId: checkoutShippingFormId,
    formRef: checkoutShippingFormRef
  }));
};

var CheckoutShippingSubpage = forwardRef(CheckoutShippingSubpageWithRef);
export { CheckoutShippingSubpage };